// extracted by mini-css-extract-plugin
export default {"extensionUpsellButton":"ExtensionUpsellButton_extensionUpsellButton__4lTO8"};